<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix" style="min-height: 270px">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>S314服務機關資料維護-查詢條件</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>機關代碼</td>
                <td><input type="text" v-model="form.govCode" /></td>
              </tr>
              <tr>
                <td>機關名稱</td>
                <td><input type="text" v-model="form.govName" /></td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="查詢"
                        @click="
                          () => {
                            this.form.currentpage = 1;
                            this.form.pagesize = 10;
                            this.doQuery();
                          }
                        "
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="新增"
                        @click="btnAdd('I', '')"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tr>
              <td v-if="grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="form.currentpage = grid.paginaiton.pageNo - 1"
                  v-show="grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                  "
                  @click="form.currentpage = parseInt(data)"
                >
                  {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                  @click="form.currentpage = grid.paginaiton.pageNo + 1"
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ grid.paginaiton.totalPage }} 頁
                {{ grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th colspan="2">操作</th>
                    <th width="10%">服務機關代碼</th>
                    <th width="10%">服務機關名稱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="修改機關"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnAdd('U', data)"
                      />
                    </td>
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        data-toggle="modal"
                        data-target=".bs-example-modal-lg"
                        @click="btnDelete(data)"
                      />
                    </td>
                    <td>{{ data.goV_CODE }}</td>
                    <td>{{ data.goV_NAME }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </div>
    <CyFooter />
    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :ServiceUnit="pageData.ServiceUnit"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>機關代碼</td>
              <td>
                <input
                  type="text"
                  v-model="addModal.form.govCode"
                  :disabled="addModal.form.type == 'U'"
                />
              </td>
            </tr>
            <tr>
              <td>機關名稱</td>
              <td>
                <input type="text" size="80" v-model="addModal.form.govName" />
              </td>
            </tr>
            <tr>
              <td>機關地址</td>
              <td>
                <select
                  style="min-width: 100px"
                  v-model="addModal.form.cityCode"
                >
                  <option
                    v-for="(item, index) in addModal.dropDownList.codes"
                    :value="item.cityCode"
                    :key="index"
                  >
                    {{ item.cityName }}
                  </option>
                </select>
                <select
                  style="min-width: 100px"
                  v-model="addModal.form.zoneCode"
                >
                  <option
                    v-for="(item, index) in addModal.dropDownListZone.areas"
                    :value="item.areaCode"
                    :key="index"
                  >
                    {{ item.area }}
                  </option>
                </select>
                <input
                  type="text"
                  size="50"
                  maxlength="50"
                  v-model="addModal.form.addr"
                />
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnModalClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <Alert
      v-model="Alert.show"
      :title="Alert.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import CyFooter from "@/components/Common/CyFooter.vue";
import {
  S314_SearchGrid,
  S314_Remove,
  S314_AddSave,
  S314_EditSave,
  GetCityCountryDropDownMenu,
} from "@/service/api.js";
import { logOut } from "@/config/util.js";
export default {
  name: "S314",
  data: function () {
    return {
      pageData: {
        MenuIndex: 3,
        PrgName: "S314",
        ServiceUnit: "CY",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        govCode: "",
        govName: "",
        pagesize: 10,
        currentpage: 1,
      },
      grid: [],
      addModal: {
        show: false,
        title: "S314服務機關資料維護-編輯受理申報機關",
        form: {
          type: "",
          govCode: "",
          govName: "",
          cityCode: "",
          zoneCode: "",
          addr: "",
        },
        grid: [],
        dropDownList: {},
        dropDownListZone: {},
      },
      Alert: {
        show: false,
        title: "",
        txt: "",
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    CyFooter,
    Alert: VueModal,
    AddModal: VueModal,
  },
  methods: {
    doQuery: function () {
      const self = this;
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        GOV_CODE: self.form.govCode,
        GOV_NAME: self.form.govName,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S314_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    btnAdd: function (type, data) {
      const self = this;
      self.btnModalClear();
      self.GetCiy(type, data);
    },
    btnClear: function () {
      const self = this;
      self.form.govCode = "";
      self.form.govName = "";
    },
    btnDelete: function (data) {
      const self = this;
      let postData = {
        GOV_CODE: data.goV_CODE,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S314_Remove(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["刪除失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnModalSave: function () {
      const self = this;
      let postData = {};

      if (self.addModal.form.type == "U") {
        postData = {
          GOV_CODE: self.addModal.form.govCode,
          GOV_NAME: self.addModal.form.govName,
          CITY_CODE: self.addModal.form.cityCode,
          ZONE_CODE: self.addModal.form.zoneCode,
          ADDR: self.addModal.form.addr,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "修改機關-存檔",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S314_EditSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["更新成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.addModal.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["更新失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
            self.addModal.show = false;
          }
        });
      }

      if (self.addModal.form.type == "I") {
        postData = {
          GOV_CODE: self.addModal.form.govCode,
          GOV_NAME: self.addModal.form.govName,
          CITY_CODE: self.addModal.form.cityCode,
          ZONE_CODE: self.addModal.form.zoneCode,
          ADDR: self.addModal.form.addr,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        S314_AddSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["新增成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.addModal.show = false;
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["新增失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
            self.addModal.show = false;
          }
        });
      }
    },
    btnModalClear: function () {
      const self = this;
      self.addModal.form.govCode = "";
      self.addModal.form.govName = "";
      self.addModal.form.cityCode = "";
      self.addModal.form.zoneCode = "";
      self.addModal.form.addr = "";
    },
    GetCiy: function (type, data) {
      const self = this;
      GetCityCountryDropDownMenu().then((rData) => {
        self.addModal.dropDownList = rData.returnObject;

        self.addModal.form.type = type;
        if (type == "U") {
          self.addModal.dropDownListZone =
            self.addModal.dropDownList.codes.filter(
              (x) => x.cityCode == data.citY_CODE
            )[0];
          self.addModal.form.govCode = data.goV_CODE;
          self.addModal.form.govName = data.goV_NAME;
          self.addModal.form.cityCode = data.citY_CODE;
          self.addModal.form.zoneCode = data.zonE_CODE;
          self.addModal.form.addr = data.addr;
          self.addModal.show = true;
        } else {
          self.addModal.show = true;
        }
      });
    },
  },
  created() {
    this.doQuery();
  },
  watch: {
    "addModal.form.cityCode": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.addModal.form.zoneCode = "";
        self.addModal.dropDownListZone = [];
      } else {
        //var a = self.addModal.dropDownList.codes;
        self.addModal.dropDownListZone =
          self.addModal.dropDownList.codes.filter(
            (x) => x.cityCode == newValue
          )[0];
      }
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Cy.css" />

